import { Button } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import SubmitAssignment from "../modals/SubmitAssignment"
import { CardStat } from "./CardComps"
import { CardContainer } from "./CardContainer"

export const AssignmentExamCard = () => {
  return (
    <CardContainer
      SummaryContent={
        <>
          <CardStat label="Name" value="Assignment 1" />
          <CardStat label="Type" value="Quiz" />
          <CardStat label="Mode" value="Online" />
          <CardStat label="Timing" value="6:30 PM 18 Jun, 2022" />
        </>
      }
      ActionButtons={
        <Link style={{ width: "100%" }} to={`/classes/submissions/exams/id`}>
          <Button variant="contained">Submit</Button>
        </Link>
      }
      DetailsContent={
        <>
          <CardStat label="Course" value="Course 1" />
          <CardStat label="Batch" value="Batch 1" />
          <CardStat label="Submissions" value="25" />
        </>
      }
    />
  )
}

export const AssignmentCard = () => {
  const [submit, setSubmit] = useState(false)

  const openSubmit = () => setSubmit(true)
  const closeSubmit = () => setSubmit(false)

  return (
    <>
      <CardContainer
        SummaryContent={
          <>
            <CardStat label="Name" value="Assignment 1" />
            <CardStat label="Type" value="Quiz" />
            <CardStat label="Mode" value="Online" />
            <CardStat label="Timing" value="6:30 PM 18 Jun, 2022" />
          </>
        }
        ActionButtons={
          <>
            <Link style={{ width: "100%" }} to={`/classes/submissions/assignments/id`}>
              <Button variant="contained">View</Button>
            </Link>
            <Button onClick={openSubmit} variant="contained">
              Submit
            </Button>
          </>
        }
        DetailsContent={
          <>
            <CardStat label="Course" value="Course 1" />
            <CardStat label="Batch" value="Batch 1" />
            <CardStat label="Submissions" value="25" />
          </>
        }
      />
      <SubmitAssignment isOpen={submit} close={closeSubmit} />
    </>
  )
}
